// apps/web/src/components/painel/home/estado-vazio.tsx — Fase 17.8, Plano 07 (D-22; UI-SPEC U-24).
// Estado vazio de UMA linha dentro do próprio card: ícone Lucide leve de 16px na tinta do perfil (decorativo), texto Body 400
// muted, altura natural (sem min-height, sem ilustração, sem título). Zero, indisponível e sem medição continuam distintos.
import type { ReactElement } from 'react';
import type { LucideIcon } from 'lucide-react';
import '../../../styles/painel-home.css';

export interface EstadoVazioProps {
  readonly icone: LucideIcon;
  readonly texto: string;
}

export function EstadoVazio({ icone: Icone, texto }: EstadoVazioProps): ReactElement {
  return (
    <p className="painel-vazio" data-testid="painel-estado-vazio">
      <Icone className="painel-vazio__icone size-4" aria-hidden="true" />
      <span>{texto}</span>
    </p>
  );
}
